export default "__VITE_ASSET__e939c8c3__"